<template>
<div class="CapitalList bgc">
    <div class="WithdrawalList-header">
        <div class="box">
            <div class="name">总余额（元）</div>
            <div class="value">￥{{summary.balance}}</div>
        </div>
        <div class="box">
            <div class="name">收入余额（元）</div>
            <div class="value">￥{{summary.borderbalance}}</div>
        </div>
        <div class="box">
            <div class="name">充值余额（元）</div>
            <div class="value">￥{{summary.bbalance}}</div>
        </div>
        <div class="box">
            <div class="name">可提现余额（元）</div>
            <div class="value">￥{{summary.bcashbalance}}</div>
        </div>
        <div class="btn">
            <el-button type="primary" plain @click="handlerechange">充值</el-button>
            <el-button type="primary" @click="handleWithdrawal">提现</el-button>
        </div>
    </div>
    <div class="filters">
        <div class="add">
            <el-button type="success" @click="handleExport">导出</el-button>
        </div>
        <div class="search">
            <el-date-picker value-format="yyyy-MM-dd"
                            v-model="timeSlot"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
            <el-select v-model="param.tradetype" placeholder="交易类型" class="condition" clearable>
                <el-option v-for="item in tradetypeList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="tradename" label="交易内容" min-width="250px" class-name="title"></el-table-column>
            <!-- <el-table-column prop="tradememo" label="交易信息" class-name="center" min-width="150px"></el-table-column> -->
            <el-table-column prop="typename" label="交易类型" class-name="center" min-width="120px">
                <template slot-scope="scope">{{scope.row.typename}}</template>
            </el-table-column>
            <el-table-column prop="tradetime" label="时间" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="trademoney" label="交易金额（元）" class-name="center" min-width="120px">
                <template slot-scope="scope"><span :class="tradetype(scope.row.tradetype)">{{scope.row.moneydirect==1?'+':'-'}}￥{{scope.row.trademoney}}</span></template>
            </el-table-column>
            <el-table-column prop="tradememo" label="交易说明" class-name="tr" min-width="150px" label-class-name="tr">
                <template slot-scope="scope"><div class="tr">{{scope.row.tradememo}}</div></template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
    <rechargeDialog ref="rechargeDialog"></rechargeDialog>
</div>
</template>

<script>
import {getTradeLogListByHost, downloadTradeLogListByHost, getProviderTradeLogListByHost, downProviderloadTradeLogListByHost} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import {brandBusiness} from 'api/enumCode'
import RechargeDialog from 'views/brandBusiness/capitalMgt/components/rechargeDialog.vue'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'CapitalList',
    props: ['hostroletype'],
    data() {
        return {
            param: {
                begintime: '',
                endtime: '',
                hostroletype: '',
                moneydirect: '',
                tradetype: ''
            },
            summary: {
                balance: '',
                bbalance: '',
                bcashbalance: '',
                borderbalance: ''
            },
            timeSlot: null,
            tradetypeList: brandBusiness.tradetype,
            page: {
                page: 1,
                pageSize: 10
            },
            tableData: [],
            total: 0
        }
    },
    mounted() {
        if (!this.isRefresh) {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        }
    },
    activated() {
        if (this.isRefresh) {
            if (this.isRefresh === 2) {
                this.param = {
                    begintime: '',
                    endtime: '',
                    hostroletype: '',
                    moneydirect: '',
                    tradetype: ''
                }
                this.page.page = 1
            }
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleQuery() {
            this.page.page = 1
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        handlerechange() {
            this.$refs.rechargeDialog.openDialog(this.hostroletype)
        },
        handleWithdrawal() {
            if (this.hostroletype == 2) {
                this.$router.push({name: 'BBWithdrawal', query: {hostroletype: this.hostroletype}})
            } else {
                this.$router.push({name: 'SPWithdrawal', query: {hostroletype: this.hostroletype}})
            }
        },
        handleExport() {
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._export()
            } else {
                this._export2()
            }
        },
        _export() {
            this.setLoading(true)
            downloadTradeLogListByHost({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '资金明细' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _export2() {
            this.setLoading(true)
            downProviderloadTradeLogListByHost({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '资金明细' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            getTradeLogListByHost({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    if (this.page.page === 1) this.summary = data.data.summary
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList2() {
            this.setLoading(true)
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            getProviderTradeLogListByHost({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    if (this.page.page === 1) this.summary = data.data.summary
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        tradetype() {
            return function (value) {
                for (let i = 0; i < brandBusiness.tradetype.length; i++) {
                    if (value === brandBusiness.tradetype[i].code) {
                        return brandBusiness.tradetype[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters(['isRefresh'])
    },
    components: {
        RechargeDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.CapitalList {
    padding: 20px;
    .WithdrawalList-header {
        padding: 20px;
        background:  #F5F7FA ;
        display: flex;
        margin-bottom: 30px;
        .box{
            flex-grow: 1;
            height: 100px;
            flex-direction: column;
            justify-content: space-between;
            display: flex;
            font-size: 16px;
            min-width: 200px;
            .value{
                font-size: 24px;
            }
        }
        .box + .box{
            border-left: 1px solid #DCDFE6 ;
        }
        .box:nth-child(n+2) {
            align-items: center;
        }
        .box:first-child .value{
            font-size: 30px;
        }
        .btn{
            flex-direction: column;
            justify-content: space-between;
            display: flex;
            .el-button+.el-button{
                margin: 0;
            }
        }
    }
    .el-range-editor.el-input__inner{
        width: 240px;
        margin-right: 20px;
    }
    .el-date-editor .el-range-separator{
        line-height: 26px;
    }
}
</style>
